export enum ChargerPhaseType {
	MONOPHASE = 'MONOPHASE',
	TRIPHASE = 'TRIPHASE',
}
